export enum CourtEventDetailsActionTypes {
    GoToEventList = '[CourtEventDetails] Go to Event List',

    LoadBlockedSlotDetails = '[CourtEventDetails] Load blocked slot details',
    ClearLoadedBlockedSlotDetails = '[CourtEventDetails] Clear loaded blocked slot details',

    LoadCourtClassDetails = '[CourtEventDetails] Load court class details',
    ClearLoadedCourtClassDetails = '[CourtEventDetails] Clear loaded court class details',

    LoadCourtBookingDetails = '[CourtEventDetails] Load court booking details',
    ClearLoadedCourtBookingDetails = '[CourtEventDetails] Clear loaded court booking details',
    NoShowAllCourtBookingDetails = '[CourtEventDetails] No show all for court booking',
    CheckInAllCourtBookingDetails = '[CourtEventDetails] Check in all for court booking',
    CheckInPlayerCourtBookingDetails = '[CourtEventDetails] Check in player for court booking'
}

export class LoadBlockedSlotDetailsAction {
    static type = CourtEventDetailsActionTypes.LoadBlockedSlotDetails;
    constructor(public courtEventId: string) {}
}

export class ClearLoadedBlockedSlotDetailsAction {
    static type = CourtEventDetailsActionTypes.ClearLoadedBlockedSlotDetails;
    constructor() {}
}

export class LoadCourtClassDetailsAction {
    static type = CourtEventDetailsActionTypes.LoadCourtClassDetails;
    constructor(public courtEventId: string) {}
}

export class ClearLoadedCourtClassDetailsAction {
    static type = CourtEventDetailsActionTypes.ClearLoadedCourtClassDetails;
    constructor() {}
}

export class LoadCourtBookingDetailsAction {
    static type = CourtEventDetailsActionTypes.LoadCourtBookingDetails;
    constructor(public courtEventId: string) {}
}

export class ClearLoadedCourtBookingDetailsAction {
    static type = CourtEventDetailsActionTypes.ClearLoadedCourtBookingDetails;
    constructor() {}
}

export class NoShowAllCourtBookingDetailsAction {
    static type = CourtEventDetailsActionTypes.NoShowAllCourtBookingDetails;
    constructor(public courtEventId: string) {}
}

export class CheckInAllCourtBookingDetailsAction {
    static type = CourtEventDetailsActionTypes.CheckInAllCourtBookingDetails;
    constructor(public courtEventId: string) {}
}

export class CheckInPlayerCourtBookingDetailsAction {
    static type = CourtEventDetailsActionTypes.CheckInPlayerCourtBookingDetails;
    constructor(public courtEventId: string, public personId: string) {}
}